<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script setup>
import { onBeforeMount } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { useTheme } from 'vuetify'

const route = useRoute()
const store = useStore()
const theme = useTheme()

onBeforeMount(() => {
  if (route.query?.devMode) {
    store.dispatch('setDevelopMode', true)
  }

  const prefersDark =
    window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches

  // Vuetify 3 theme switching
  theme.global.name.value = prefersDark ? 'dark' : 'light'
})
</script>